import { Dayjs } from 'dayjs'
import { useQuery } from 'react-query'
import { axiosInstance } from 'service/api/axios'
import { UseFetch } from 'service/api/types'

export interface Logs {
    id: number
}

type DatetimeLog =
    | Dayjs
    | [Dayjs, Dayjs]
    | 'today'
    | 'yesterday'
    | 'week'
    | 'month'
    | 'year'

interface Params {
    clienteId: string | null
    operacao: string | null
    datetime?: DatetimeLog
}

export const useFetchLog: UseFetch<Logs, Params> = options => {
    const queryParams = options?.queryParams ?? ({} as Params)

    const path = new URL(axiosInstance.defaults.baseURL + '/v1/logs')

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value) {
            path.searchParams.append(key, value.toString())
        }
    })

    const url = path.toString()

    return useQuery(
        ['logs', 'v1', queryParams],
        ({ signal }) => axiosInstance.get(url, { signal }),
        options,
    )
}
